import { render, staticRenderFns } from "./AboutSmartBone.vue?vue&type=template&id=300eb2a7&scoped=true"
import script from "./AboutSmartBone.vue?vue&type=script&lang=js"
export * from "./AboutSmartBone.vue?vue&type=script&lang=js"
import style0 from "./AboutSmartBone.vue?vue&type=style&index=0&id=300eb2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300eb2a7",
  null
  
)

export default component.exports